module.exports = __webpack_public_path__ + "static/img/2024.ea9223e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huaiBrand/2024.png
// module id = AQdZ
// module chunks = 0